"use client"

import { SAME_SHIPPING_ADDRESS_STORAGE_KEY } from "@/lib/siteconfig/constants"
import { useEffect, useState } from "react"

/**
 * Custom hook to get and sync sameShippingAddress state from sessionStorage
 * @returns The sameShippingAddress state value (defaults to true)
 */
export const useGetSameShippingAddress = (): boolean => {
    const [sameShippingAddress, setSameShippingAddress] = useState<boolean>(true)

    useEffect(() => {
        const stored = sessionStorage.getItem(SAME_SHIPPING_ADDRESS_STORAGE_KEY)
        if (stored !== null) {
            setSameShippingAddress(stored === "true")
        }
    }, [sameShippingAddress])

    return sameShippingAddress
}
